import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

type AuthLoadingScreenProps = {
  title: string
  subtitle?: string
  icon?: React.ReactNode
}

const AuthLoadingScreen = ({ title, subtitle, icon }: AuthLoadingScreenProps): JSX.Element => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #F0F4F8 0%, #E0F7FA 50%, #F0F4F8 100%)',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: icon || subtitle ? 3 : 2.5,
        p: 5,
        borderRadius: 4,
        bgcolor: 'white',
        boxShadow: '0 8px 32px rgba(0, 124, 145, 0.12)',
        border: '1px solid rgba(0, 124, 145, 0.08)',
      }}
    >
      {icon}
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: '#263238', mb: subtitle ? 0.5 : 0 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" sx={{ color: '#78909C' }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      <CircularProgress size={28} sx={{ color: '#007C91' }} />
    </Box>
  </Box>
)

export default AuthLoadingScreen
